module.exports = __webpack_public_path__ + "static/media/foodie.17fb9cfd.jpg";